import React from 'react';
import NavItemBase from '@material-ui/core/BottomNavigationAction';

const NavItem = (props) => <NavItemBase {...props} />;

export default NavItem;
